// source: task.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var enums_pb = require('./enums_pb.js');
goog.object.extend(proto, enums_pb);
var general_pb = require('./general_pb.js');
goog.object.extend(proto, general_pb);
goog.exportSymbol('proto.cloud.RootTask', null, global);
goog.exportSymbol('proto.cloud.TaskInfo', null, global);
goog.exportSymbol('proto.cloud.TaskProgress', null, global);
goog.exportSymbol('proto.cloud.TaskProgress.TaskProgressUnit', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.RootTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.RootTask.repeatedFields_, null);
};
goog.inherits(proto.cloud.RootTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.RootTask.displayName = 'proto.cloud.RootTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.TaskProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.TaskProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.TaskProgress.displayName = 'proto.cloud.TaskProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.TaskInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.TaskInfo.repeatedFields_, null);
};
goog.inherits(proto.cloud.TaskInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.TaskInfo.displayName = 'proto.cloud.TaskInfo';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.RootTask.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.RootTask.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.RootTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.RootTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.RootTask.toObject = function(includeInstance, msg) {
  var f, obj = {
    info: (f = msg.getInfo()) && proto.cloud.TaskInfo.toObject(includeInstance, f),
    subTasksList: jspb.Message.toObjectList(msg.getSubTasksList(),
    proto.cloud.TaskInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.RootTask}
 */
proto.cloud.RootTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.RootTask;
  return proto.cloud.RootTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.RootTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.RootTask}
 */
proto.cloud.RootTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.TaskInfo;
      reader.readMessage(value,proto.cloud.TaskInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = new proto.cloud.TaskInfo;
      reader.readMessage(value,proto.cloud.TaskInfo.deserializeBinaryFromReader);
      msg.addSubTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.RootTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.RootTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.RootTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.RootTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud.TaskInfo.serializeBinaryToWriter
    );
  }
  f = message.getSubTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.cloud.TaskInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional TaskInfo info = 1;
 * @return {?proto.cloud.TaskInfo}
 */
proto.cloud.RootTask.prototype.getInfo = function() {
  return /** @type{?proto.cloud.TaskInfo} */ (
    jspb.Message.getWrapperField(this, proto.cloud.TaskInfo, 1));
};


/**
 * @param {?proto.cloud.TaskInfo|undefined} value
 * @return {!proto.cloud.RootTask} returns this
*/
proto.cloud.RootTask.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.RootTask} returns this
 */
proto.cloud.RootTask.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.RootTask.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TaskInfo sub_tasks = 2;
 * @return {!Array<!proto.cloud.TaskInfo>}
 */
proto.cloud.RootTask.prototype.getSubTasksList = function() {
  return /** @type{!Array<!proto.cloud.TaskInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.TaskInfo, 2));
};


/**
 * @param {!Array<!proto.cloud.TaskInfo>} value
 * @return {!proto.cloud.RootTask} returns this
*/
proto.cloud.RootTask.prototype.setSubTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.cloud.TaskInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.TaskInfo}
 */
proto.cloud.RootTask.prototype.addSubTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.cloud.TaskInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.RootTask} returns this
 */
proto.cloud.RootTask.prototype.clearSubTasksList = function() {
  return this.setSubTasksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.TaskProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.TaskProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.TaskProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.TaskProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
    progressUnit: jspb.Message.getFieldWithDefault(msg, 3, 0),
    progressToComplete: jspb.Message.getFieldWithDefault(msg, 1, 0),
    progressCompleted: jspb.Message.getFieldWithDefault(msg, 2, 0),
    secondsRemaining: jspb.Message.getFieldWithDefault(msg, 4, 0),
    secondsElapsed: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.TaskProgress}
 */
proto.cloud.TaskProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.TaskProgress;
  return proto.cloud.TaskProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.TaskProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.TaskProgress}
 */
proto.cloud.TaskProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {!proto.cloud.TaskProgress.TaskProgressUnit} */ (reader.readEnum());
      msg.setProgressUnit(value);
      break;
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProgressToComplete(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProgressCompleted(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSecondsRemaining(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSecondsElapsed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.TaskProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.TaskProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.TaskProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.TaskProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProgressUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getProgressToComplete();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getProgressCompleted();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSecondsRemaining();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSecondsElapsed();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.cloud.TaskProgress.TaskProgressUnit = {
  UNIT_NONE: 0,
  UNIT_BYTE_COUNT: 1,
  UNIT_RESOURCE_COUNT: 2,
  UNIT_FILE_COUNT: 3
};

/**
 * optional TaskProgressUnit progress_unit = 3;
 * @return {!proto.cloud.TaskProgress.TaskProgressUnit}
 */
proto.cloud.TaskProgress.prototype.getProgressUnit = function() {
  return /** @type {!proto.cloud.TaskProgress.TaskProgressUnit} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.cloud.TaskProgress.TaskProgressUnit} value
 * @return {!proto.cloud.TaskProgress} returns this
 */
proto.cloud.TaskProgress.prototype.setProgressUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 progress_to_complete = 1;
 * @return {number}
 */
proto.cloud.TaskProgress.prototype.getProgressToComplete = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.TaskProgress} returns this
 */
proto.cloud.TaskProgress.prototype.setProgressToComplete = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 progress_completed = 2;
 * @return {number}
 */
proto.cloud.TaskProgress.prototype.getProgressCompleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.TaskProgress} returns this
 */
proto.cloud.TaskProgress.prototype.setProgressCompleted = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 seconds_remaining = 4;
 * @return {number}
 */
proto.cloud.TaskProgress.prototype.getSecondsRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.TaskProgress} returns this
 */
proto.cloud.TaskProgress.prototype.setSecondsRemaining = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 seconds_elapsed = 5;
 * @return {number}
 */
proto.cloud.TaskProgress.prototype.getSecondsElapsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.TaskProgress} returns this
 */
proto.cloud.TaskProgress.prototype.setSecondsElapsed = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.TaskInfo.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.TaskInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.TaskInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.TaskInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.TaskInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    taskType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    taskPhase: jspb.Message.getFieldWithDefault(msg, 2, 0),
    taskStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    taskProgress: (f = msg.getTaskProgress()) && proto.cloud.TaskProgress.toObject(includeInstance, f),
    taskErrorsList: jspb.Message.toObjectList(msg.getTaskErrorsList(),
    general_pb.AppError.toObject, includeInstance),
    taskTimestamp: jspb.Message.getFieldWithDefault(msg, 6, ""),
    taskSourcePath: jspb.Message.getFieldWithDefault(msg, 11, ""),
    taskDestinationPath: jspb.Message.getFieldWithDefault(msg, 12, ""),
    taskStartDate: jspb.Message.getFieldWithDefault(msg, 21, ""),
    taskEndDate: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.TaskInfo}
 */
proto.cloud.TaskInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.TaskInfo;
  return proto.cloud.TaskInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.TaskInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.TaskInfo}
 */
proto.cloud.TaskInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.cloud.TaskType} */ (reader.readEnum());
      msg.setTaskType(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud.TaskPhase} */ (reader.readEnum());
      msg.setTaskPhase(value);
      break;
    case 3:
      var value = /** @type {!proto.cloud.TaskStatus} */ (reader.readEnum());
      msg.setTaskStatus(value);
      break;
    case 4:
      var value = new proto.cloud.TaskProgress;
      reader.readMessage(value,proto.cloud.TaskProgress.deserializeBinaryFromReader);
      msg.setTaskProgress(value);
      break;
    case 5:
      var value = new general_pb.AppError;
      reader.readMessage(value,general_pb.AppError.deserializeBinaryFromReader);
      msg.addTaskErrors(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskTimestamp(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskSourcePath(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskDestinationPath(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskStartDate(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.TaskInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.TaskInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.TaskInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.TaskInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTaskPhase();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTaskStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTaskProgress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.cloud.TaskProgress.serializeBinaryToWriter
    );
  }
  f = message.getTaskErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      general_pb.AppError.serializeBinaryToWriter
    );
  }
  f = message.getTaskTimestamp();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTaskSourcePath();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTaskDestinationPath();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTaskStartDate();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getTaskEndDate();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional TaskType task_type = 1;
 * @return {!proto.cloud.TaskType}
 */
proto.cloud.TaskInfo.prototype.getTaskType = function() {
  return /** @type {!proto.cloud.TaskType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.cloud.TaskType} value
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.setTaskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional TaskPhase task_phase = 2;
 * @return {!proto.cloud.TaskPhase}
 */
proto.cloud.TaskInfo.prototype.getTaskPhase = function() {
  return /** @type {!proto.cloud.TaskPhase} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud.TaskPhase} value
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.setTaskPhase = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional TaskStatus task_status = 3;
 * @return {!proto.cloud.TaskStatus}
 */
proto.cloud.TaskInfo.prototype.getTaskStatus = function() {
  return /** @type {!proto.cloud.TaskStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.cloud.TaskStatus} value
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.setTaskStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional TaskProgress task_progress = 4;
 * @return {?proto.cloud.TaskProgress}
 */
proto.cloud.TaskInfo.prototype.getTaskProgress = function() {
  return /** @type{?proto.cloud.TaskProgress} */ (
    jspb.Message.getWrapperField(this, proto.cloud.TaskProgress, 4));
};


/**
 * @param {?proto.cloud.TaskProgress|undefined} value
 * @return {!proto.cloud.TaskInfo} returns this
*/
proto.cloud.TaskInfo.prototype.setTaskProgress = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.clearTaskProgress = function() {
  return this.setTaskProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.TaskInfo.prototype.hasTaskProgress = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated AppError task_errors = 5;
 * @return {!Array<!proto.cloud.AppError>}
 */
proto.cloud.TaskInfo.prototype.getTaskErrorsList = function() {
  return /** @type{!Array<!proto.cloud.AppError>} */ (
    jspb.Message.getRepeatedWrapperField(this, general_pb.AppError, 5));
};


/**
 * @param {!Array<!proto.cloud.AppError>} value
 * @return {!proto.cloud.TaskInfo} returns this
*/
proto.cloud.TaskInfo.prototype.setTaskErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.cloud.AppError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.AppError}
 */
proto.cloud.TaskInfo.prototype.addTaskErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.cloud.AppError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.clearTaskErrorsList = function() {
  return this.setTaskErrorsList([]);
};


/**
 * optional string task_timestamp = 6;
 * @return {string}
 */
proto.cloud.TaskInfo.prototype.getTaskTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.setTaskTimestamp = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string task_source_path = 11;
 * @return {string}
 */
proto.cloud.TaskInfo.prototype.getTaskSourcePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.setTaskSourcePath = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string task_destination_path = 12;
 * @return {string}
 */
proto.cloud.TaskInfo.prototype.getTaskDestinationPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.setTaskDestinationPath = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string task_start_date = 21;
 * @return {string}
 */
proto.cloud.TaskInfo.prototype.getTaskStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.setTaskStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string task_end_date = 22;
 * @return {string}
 */
proto.cloud.TaskInfo.prototype.getTaskEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.TaskInfo} returns this
 */
proto.cloud.TaskInfo.prototype.setTaskEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


goog.object.extend(exports, proto.cloud);
